export const EDIT_MODE_HEX = 'hex'
export const EDIT_MODE_ASCII = 'ascii'

export const SELECTION_DIRECTION_FORWARD = 'forward'
export const SELECTION_DIRECTION_BACKWARD = 'backward'
export const SELECTION_DIRECTION_NONE = 'none'
